
















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name:'IQrcode'
})
export default class IQrcode extends Vue{

}
